/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Form } from 'react-final-form'
import {
  findOneVideoCategory_findOneVideoCategory as IVideoCategory,
  findOneVideoCategory_findOneVideoCategory_video as IVideo,
} from '__generatedTypes__/findOneVideoCategory'
import { SubjectEnumType } from '__generatedTypes__/globalTypes'
import DetailsBlock from 'components/DetailsBlock'
import { CourseName } from 'theme/utils'
import { validateRequired } from 'utils/validation'
import { InputField } from 'components/Input/InputField'
import * as commonClasses from '../commonStyles'
import { IResourceData } from '../types'

interface IProps {
  videoCategory: IVideoCategory
  initialValues?: Omit<IVideo, '__typename'>
  handleSubmit: (data: IResourceData) => void
  onDeleteClick?: () => void
}

const VideoResourceForm: FC<IProps> = ({ videoCategory, initialValues, handleSubmit, onDeleteClick }) => (
  <div css={commonClasses.formContainer}>
    <Typography variant="title3" css={commonClasses.title}>
      {initialValues ? 'Edit Resource' : 'Create Resource'}
    </Typography>
    <Form
      onSubmit={handleSubmit}
      initialValues={initialValues ?? {}}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} css={commonClasses.contentContainer}>
          <div css={commonClasses.block}>
            <InputField name="title" validate={validateRequired} label="Title" fullWidth />
            <InputField name="resourseURL" validate={validateRequired} label="Resource URL" fullWidth />
          </div>
          <DetailsBlock
            itemName="Video Resource"
            title="Resource Details"
            tag={
              videoCategory.subject.type === SubjectEnumType.VideosOnly
                ? CourseName.CARS
                : (videoCategory.subject.tabName as CourseName)
            }
            tagLabel={videoCategory.subject.tabName}
            createDate={initialValues?.createdAt}
            statusLive={!!initialValues?.isLive}
            onDeleteClick={onDeleteClick}
            deleteDisabledReason={
              initialValues?.isLive ? "You can't delete Video Resource because Live is enabled" : undefined
            }
          />
        </form>
      )}
    />
  </div>
)

export default VideoResourceForm
